import { render, staticRenderFns } from "./MyInputCopyTextbox.vue?vue&type=template&id=63f9af00&scoped=true&"
import script from "./MyInputCopyTextbox.vue?vue&type=script&lang=js&"
export * from "./MyInputCopyTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9af00",
  null
  
)

export default component.exports